import React from 'react'
import CoachMenuLayout from "../../../layouts/CoachMenuLayout";

const Inbox = () => {
  return (
    <div>
      <CoachMenuLayout>
        <div class="chat-area">
          <div class="chatlist ct_chatroom_chatlist ">
            <div class="ct_modal-dialog-scrollable ">
              <div class="modal-content ">
                <div className="ct_search_bg_white">
                  <div class="position-relative ">
                    <input
                      type="text"
                      class="form-control ct_input ct_input_pe_40 ct_input_h_40 ct_border_op_10 ct_border_radius_10 border-0"
                      style={{ backgroundColor: "#F8F8F9" }}
                      placeholder="Search"
                    />
                    <i class="fa-solid fa-search ct_show_eye"></i>
                  </div>
                </div>
                <div className="ct_chats_tabs">
                  <ul>
                    <li>
                      <button className="active">All</button>
                    </li>
                    <li>
                      <button>Personal </button>
                    </li>
                    <li>
                      <button>Group</button>
                    </li>
                  </ul>
                </div>
                <div class="modal-body  ct_custom_scroll">
                  <div
                    class="chat-lists  "
                    style={{ height: "calc(100vh - 397px)" }}
                  >
                    <div className="ct_pinned_messages">
                      <h5 className="ct_fs_16 ct_fw_600">
                        <img
                          src="../assets/img/chat_msg_icon.png"
                          style={{ width: "25px" }}
                        />
                        <span className="ct_text_shadow_12 ms-2">
                          Pinned Messages
                        </span>
                      </h5>
                      <ul className="chat-list">
                        <li>
                          <a href="javascript:void(0)" class="d-flex ">
                            <div class="ct_chat_list_grid">
                              <div class="position-relative">
                                <img
                                  class="img-fluid ct_img_40"
                                  src="../assets/img/chat_user.png"
                                  alt="user img"
                                />
                              </div>
                              <div class="flex-grow-1 ms-3">
                                <div class="d-flex align-items-center gap-2 justify-content-between">
                                  <div>
                                    <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                      Evelyn Shu
                                    </h3>
                                    <p className="ct_fs_12 ct_text_clr_9A96A4">
                                      applied for UI Designer
                                    </p>
                                  </div>
                                  <div>
                                    <span className="ct_text_clr_9A96A4 ct_fs_14">
                                      <img src="../assets/img/Pin.svg" /> 23min
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex align-items-center gap-2 justify-content-between">
                                  <p class="ct_fs_14 ct_overlay_text ">
                                    I’m interviewing for a FA position at the
                                    Seattle location. What are the ranges...
                                  </p>
                                </div>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="ct_pinned_messages">
                      <h5 className="ct_fs_16 ct_fw_600">
                        <img
                          src="../assets/img/chat_msg_icon.png"
                          style={{ width: "25px" }}
                        />
                        <span className="ct_text_shadow_12 ms-2">Messages</span>
                      </h5>
                      <div class="chat-list">
                        <a href="javascript:void(0)" class="d-flex active2">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                              <span class="active"></span>
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4">
                                    applied for UI Designer
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <p class="ct_fs_14 ct_overlay_text ct_overlay_text_w_150">
                                  I’m interviewing for a FA position at the
                                  Seattle location. What are the ranges...
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex ">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                              <span class="active"></span>
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4">
                                    applied for UI Designer
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <p class="ct_fs_14 ct_overlay_text ct_overlay_text_w_150">
                                  I’m interviewing for a FA position at the
                                  Seattle location. What are the ranges...
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex ">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                              <span class="active"></span>
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4">
                                    applied for UI Designer
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <p class="ct_fs_14 ct_overlay_text ct_overlay_text_w_150">
                                  I’m interviewing for a FA position at the
                                  Seattle location. What are the ranges...
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex ">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                              <span class="active"></span>
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4">
                                    applied for UI Designer
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <p class="ct_fs_14 ct_overlay_text ct_overlay_text_w_150">
                                  I’m interviewing for a FA position at the
                                  Seattle location. What are the ranges...
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex ">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                              <span class="active"></span>
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4">
                                    applied for UI Designer
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <p class="ct_fs_14 ct_overlay_text ct_overlay_text_w_150">
                                  I’m interviewing for a FA position at the
                                  Seattle location. What are the ranges...
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex ">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                              <span class="active"></span>
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4">
                                    applied for UI Designer
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <p class="ct_fs_14 ct_overlay_text ct_overlay_text_w_150">
                                  I’m interviewing for a FA position at the
                                  Seattle location. What are the ranges...
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex ">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                              <span class="active"></span>
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4">
                                    applied for UI Designer
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <p class="ct_fs_14 ct_overlay_text ct_overlay_text_w_150">
                                  I’m interviewing for a FA position at the
                                  Seattle location. What are the ranges...
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chatbox ">
            <div class="ct_white_bg ct_border_radius_10 ct_p_20 h-100">
              <div class="ct_modal-dialog-scrollable">
                <div class="modal-content ct_chatroom_modal_content">
                  <div class="d-block">
                    <div class="msg-head d-flex align-items-center justify-content-between gap-3 flex-wrap">
                      <div class="d-flex align-items-center gap-2 ">
                        <i class="fa-solid fa-chevron-left chat-icon"></i>
                        <div class="ct_grid_50_auto">
                          <img src="../assets/img/chat_user.png" alt="" />
                          <div>
                            <h4 class="ct_fs_18 ct_fw_600  mb-0">John Smith</h4>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center gap-3 justify-content-end">
                        <button class="ct_view_profile_btn ct_h_50">
                          View Profile
                        </button>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select className="form-control ct_input ct_border_radius_10 ct_border_color_EAEDF5 ct_h_50">
                            <option>No Stage</option>
                            <option>Personal</option>
                            <option>Group</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="msg-body ct_custom_scroll">
                        <ul>
                          <li>
                            <div>
                              <div class="sender">
                                <h5 class="ct_fs_16  mb-2 ">
                                  Hey, I have a question about my recent order
                                  #12345. When can I expect it to be delivered?
                                </h5>
                                <small className="ct_text_clr_9A96A4 text-end d-block">
                                  12:02 PM
                                </small>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div class="repaly">
                              <p>
                                Hi John, your order is currently in transit and
                                should arrive within 2-3 business days. You can
                                track it using the tracking number sent to your
                                email.
                              </p>
                              <small className="text-white text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="sender">
                              <h5 class="ct_fs_16  mb-2 ">
                                Hey, I have a question about my recent order
                                #12345. When can I expect it to be delivered?
                              </h5>
                              <small className="ct_text_clr_9A96A4 text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="repaly">
                              <p>
                                Hi John, your order is currently in transit and
                                should arrive within 2-3 business days. You can
                                track it using the tracking number sent to your
                                email.
                              </p>
                              <small className="text-white text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="sender">
                              <h5 class="ct_fs_16  mb-2 ">
                                Hey, I have a question about my recent order
                                #12345. When can I expect it to be delivered?
                              </h5>
                              <small className="ct_text_clr_9A96A4 text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="repaly">
                              <p>
                                Hi John, your order is currently in transit and
                                should arrive within 2-3 business days. You can
                                track it using the tracking number sent to your
                                email.
                              </p>
                              <small className="text-white text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="sender">
                              <h5 class="ct_fs_16  mb-2 ">
                                Hey, I have a question about my recent order
                                #12345. When can I expect it to be delivered?
                              </h5>
                              <small className="ct_text_clr_9A96A4 text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="repaly">
                              <p>
                                Hi John, your order is currently in transit and
                                should arrive within 2-3 business days. You can
                                track it using the tracking number sent to your
                                email.
                              </p>
                              <small className="text-white text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="sender">
                              <h5 class="ct_fs_16 ct_fw_600 mb-2  ">
                                Hey, I have a question about my recent order
                                #12345. When can I expect it to be delivered?
                              </h5>
                              <small className="ct_text_clr_9A96A4 text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="repaly">
                              <p>
                                Hi John, your order is currently in transit and
                                should arrive within 2-3 business days. You can
                                track it using the tracking number sent to your
                                email.
                              </p>
                              <small className="text-white text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="sender">
                              <h5 class="ct_fs_16 ct_fw_600 mb-2  ">
                                Hey, I have a question about my recent order
                                #12345. When can I expect it to be delivered?
                              </h5>
                              <small className="ct_text_clr_9A96A4 text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                          <li>
                            <div class="repaly">
                              <p>
                                Hi John, your order is currently in transit and
                                should arrive within 2-3 business days. You can
                                track it using the tracking number sent to your
                                email.
                              </p>
                              <small className="text-white text-end d-block">
                                12:02 PM
                              </small>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="send-box ">
                      <form action="" class="position-relative">
                        <div
                          className="form-control h-auto py-3 ct_para_scroll ct_custom_scroll"
                          style={{ minHeight: "48px" }}
                          contentEditable
                          data-placeholder="Your message"
                        ></div>
                        <div class="ct_right_side_send_chat_btns">
                          Send <i class="fa-solid fa-paper-plane"></i>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="ct_empty_chat_box_content d-none">
                    <svg
                      width="123"
                      height="123"
                      viewBox="0 0 123 123"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.956267"
                        y="1.3696"
                        width="120.87"
                        height="120.87"
                        rx="60.4348"
                        fill="#F4F5FA"
                      />
                      <rect
                        x="0.956267"
                        y="1.3696"
                        width="120.87"
                        height="120.87"
                        rx="60.4348"
                        stroke="#E1E2E9"
                        stroke-width="0.869565"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M76.764 77.1737C70.1202 83.8182 60.2823 85.2538 52.2315 81.5305C51.043 81.052 50.0686 80.6653 49.1423 80.6653C46.5621 80.6806 43.3505 83.1824 41.6814 81.5152C40.0122 79.8459 42.516 76.6318 42.516 74.036C42.516 73.1096 42.1446 72.1526 41.6661 70.9618C37.9411 62.9123 39.3787 53.0711 46.0225 46.4288C54.5036 37.9445 68.2828 37.9445 76.764 46.4266C85.2605 54.924 85.2452 68.6916 76.764 77.1737Z"
                        fill="#BEC0CA"
                        stroke="#8B8D97"
                        stroke-width="1.30435"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M69.9541 62.7022H69.9737"
                        stroke="#8B8D97"
                        stroke-width="1.73913"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M61.2412 62.7022H61.2608"
                        stroke="#8B8D97"
                        stroke-width="1.73913"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M52.5244 62.7022H52.544"
                        stroke="#8B8D97"
                        stroke-width="1.73913"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div>
                      <h4 class="ct_fs_20 ct_fw_600">Messages</h4>
                      <p>Click on a contact to view messages.</p>
                      <div class="">
                        <a
                          href="#"
                          class="ct_purple_btn d-flex align-items-center gap-2"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.8447 16.039C13.1871 18.6968 9.25198 19.271 6.03167 17.7817C5.55627 17.5903 5.16651 17.4356 4.79598 17.4356C3.7639 17.4417 2.47927 18.4425 1.81162 17.7756C1.14396 17.1079 2.14545 15.8222 2.14545 14.7839C2.14545 14.4133 1.99688 14.0305 1.8055 13.5542C0.315505 10.3344 0.890529 6.39795 3.54805 3.74101C6.94052 0.347298 12.4522 0.347298 15.8447 3.74014C19.2432 7.1391 19.2371 12.6461 15.8447 16.039Z"
                              stroke="white"
                              stroke-width="1.30435"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.1203 10.2505H13.1281"
                              stroke="white"
                              stroke-width="1.73913"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M9.63595 10.2505H9.64377"
                              stroke="white"
                              stroke-width="1.73913"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.14962 10.2505H6.15745"
                              stroke="white"
                              stroke-width="1.73913"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span> New Message</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CoachMenuLayout>
    </div>
  );
};

export default Inbox